export default __webpack_public_path__ + "static/media/034-dragon.63095de3.svg";